module.exports = __webpack_public_path__ + "media/images/applicant/icon-calendar-58acb30a739d07f268f68ef73758cfc9.svg";